import React, { useMemo } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import plugins from "suneditor/src/plugins";

const SeoContentAccordian = ({ title, data, setData }) => {
    const editorOptions = useMemo(
        () => ({
            plugins,
            buttonList: [
                ["undo", "redo"],
                ["formatBlock"],
                ["font", "fontSize"],
                ["bold", "italic", "underline", "strike"],
                ["fontColor", "hiliteColor"],
                ["align", "list", "lineHeight"],
                ["link", "image", "video", "table"],
                ["fullScreen", "showBlocks", "template"],
                ["removeFormat"],
            ],
            removeFormatTags: ["b", "strong", "span", "font", "h1", "h2", "h3", "h4", "h5", "h6"],
            removeFormatAttributes: ["style", "class"],
        }),
        []
    );

    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6a-content"
                id="panel6a-header"
            >
                <Typography
                    fontWeight={600}
                    sx={{ fontFamily: (theme) => theme.typography.fontFamily }}
                >
                    {title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div className="form_comp">
                    <label className="title">SEO Content</label>
                    <SunEditor

                        defaultValue={data?.seoContent}
                        onChange={(content) =>
                            setData((prev) => ({ ...prev, seoContent: content }))
                        }
                        height="300px"
                        setOptions={editorOptions}
                    />
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default SeoContentAccordian;